export const TECHNICAL_CATEGORY_PLACEHOLDER = 'TO_BE_DETERMINED';

// Mirrors the backend's CategoryUtils.isDisplayableCategory(...) — the
// TO_BE_DETERMINED sentinel must stay in the API contract for routing /
// escalation rule matching, so SSP filters it out at every render site.
export function isDisplayableCategoryValue(field) {
    if (!field || typeof field.valueCaption !== 'string') {
        return false;
    }
    const caption = field.valueCaption;
    if (caption.replace(/ /g, '') === '') {
        return false;
    }
    return caption.trim().toUpperCase() !== TECHNICAL_CATEGORY_PLACEHOLDER;
}

// Replaces the technical-category sentinel with '' on a copy of `field`.
// Identity-preserving for displayable captions and non-string inputs.
export function scrubCategoryFieldCaption(field) {
    if (!field || typeof field.valueCaption !== 'string') {
        return field;
    }
    if (isDisplayableCategoryValue(field)) {
        return field;
    }
    return { ...field, valueCaption: '' };
}



// WEBPACK FOOTER //
// ./utils/category.js